import React, { useRef } from 'react'
import { CSSTransition } from 'react-transition-group'

interface IAnimatedContainerProps {
    loading: boolean
    children?: JSX.Element | JSX.Element[]
    notDiv?: boolean
}

export const AnimatedContainer: React.FC<IAnimatedContainerProps> = ({
    loading,
    children,
    notDiv,
}): JSX.Element => {
  const nodeRef = useRef<HTMLDivElement>(null)

    return (
        <CSSTransition
            nodeRef={nodeRef}
            in={loading}
            timeout={300}
            classNames="loading"
            appear={true}
        >
            {notDiv ? (
                <div ref={nodeRef} style={{ display: 'contents' }}>
                    {children}
                </div>
            ) : (
                <div ref={nodeRef}>{children}</div>
            )}
        </CSSTransition>
    )
}
